import Vue from 'vue'

import VueAwesomeSwiper from 'vue-awesome-swiper'
import Paginate from 'vuejs-paginate'
import smoothscroll from 'smoothscroll-polyfill';
smoothscroll.polyfill();

import router from './router'
import './plugins/axios';
import { i18n, trySetUserLanguage } from "./plugins/i18n.plugin"
import 'lazysizes';
import 'lazysizes/plugins/unveilhooks/ls.unveilhooks';

import App from './App.vue'
import LazyImage from './components/lazyimage.vue'
import AutoPlayVideo from './components/autoplayvideo.vue'
import SilentboxSingle from './components/vue-silentbox/components/single.vue'
import Loader from './components/loader.vue'

Vue.config.productionTip = false

Vue.use(VueAwesomeSwiper)

Vue.component('paginate', Paginate);

Vue.component('limg', LazyImage)
Vue.component('avideo', AutoPlayVideo)
Vue.component('silentbox-single', SilentboxSingle)
Vue.component('loader', Loader)

trySetUserLanguage()
  .then(start)


function start() {
  return new Vue({
    router,
    i18n,
    render: h => h(App)
  }).$mount('#app')
}
